"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ProviderLabel = exports.ProviderIdentityFlag = void 0;
var lodash_uniqby_1 = __importDefault(require("lodash.uniqby"));
var helpers_1 = require("./helpers");
var types_1 = require("./types");
var validation_1 = require("./validation");
var wallets_1 = __importDefault(require("./wallets"));
var types_2 = require("./types");
__createBinding(exports, types_2, "ProviderIdentityFlag");
__createBinding(exports, types_2, "ProviderLabel");
function injected(options) {
    if (typeof window === 'undefined')
        return function () { return null; };
    if (options) {
        var result = (0, validation_1.validateWalletOptions)(options);
        if (result && result.error)
            throw result.error;
    }
    return function (helpers) {
        var device = helpers.device;
        var _a = options || {}, _b = _a.custom, custom = _b === void 0 ? [] : _b, _c = _a.filter, filter = _c === void 0 ? {} : _c;
        var allWallets = __spreadArray(__spreadArray([], custom, true), wallets_1["default"], true);
        var deduped = (0, lodash_uniqby_1["default"])(allWallets, function (_a) {
            var label = _a.label;
            return "".concat(label);
        });
        var filteredWallets = deduped.filter(function (wallet) {
            var label = wallet.label, platforms = wallet.platforms;
            var walletFilters = filter[label];
            var filteredWallet = walletFilters === false;
            var excludedDevice = Array.isArray(walletFilters) &&
                (walletFilters.includes(device.type) ||
                    walletFilters.includes(device.os.name));
            var invalidPlatform = !platforms.includes('all') &&
                !platforms.includes(device.type) &&
                !platforms.includes(device.os.name);
            var supportedWallet = !filteredWallet && !excludedDevice && !invalidPlatform;
            return supportedWallet;
        });
        var removeMetaMask = false;
        var validWallets = filteredWallets.filter(function (_a) {
            var injectedNamespace = _a.injectedNamespace, checkProviderIdentity = _a.checkProviderIdentity, label = _a.label;
            var provider = window[injectedNamespace];
            if (!provider)
                return null;
            var walletExists;
            if (provider.providers && Array.isArray(provider.providers)) {
                walletExists = !!provider.providers.filter(function (provider) { return device && checkProviderIdentity({ provider: provider, device: device }); }).length;
            }
            else {
                if (device) {
                    walletExists = checkProviderIdentity({ provider: provider, device: device });
                }
            }
            if (walletExists &&
                provider.isMetaMask &&
                !provider.overrideIsMetaMask &&
                label !== types_1.ProviderLabel.MetaMask &&
                label !== types_1.ProviderLabel.Detected) {
                removeMetaMask = true;
            }
            return walletExists;
        });
        if (validWallets.length) {
            var moreThanOneWallet = validWallets.length > 1;
            // if more than one wallet, then remove detected wallet
            return validWallets
                .filter((0, helpers_1.remove)({
                detected: moreThanOneWallet,
                metamask: moreThanOneWallet && removeMetaMask
            }))
                .map(function (_a) {
                var label = _a.label, getIcon = _a.getIcon, getInterface = _a.getInterface;
                return ({
                    label: label,
                    getIcon: getIcon,
                    getInterface: getInterface
                });
            });
        }
        return [];
    };
}
exports["default"] = injected;
